export default "__VITE_ASSET__B4FRe7da__"